const styles = {
  sectionCover: {
    backgroundColor: `rgba(0,0,0,.4)`,
    minWidth: '100%',
    height: '100%'
  }
};

export default styles;
